<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Bulk Leaving Certificate</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="2">
                    <v-select v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" @change="clearSelected()"
                        outlined dense />
                </v-col>

                <v-col cols="12" sm="2">
                    <v-select v-model="section" :items="sections_list" item-text="name" item-value="id" label="Section"
                        outlined dense @change="getStandardBySection()" />
                </v-col>
                <v-col cols="12" sm="2" v-if="section">
                    <v-select v-model="standard" :disabled="!section" :items="standard_list_no_all" item-text="standard"
                        item-value="id" label="Standard" outlined dense @change="getDivOffByStandard()" />
                </v-col>
                <v-col cols="12" sm="2" v-if="standard">
                    <v-select v-model="division" :items="division_list" item-text="division" item-value="div_off_id"
                        label="Division" outlined dense @change="getStud()" />
                </v-col>

                <v-col cols="12" sm="3" v-if="division">
                    <v-autocomplete v-model="selectedStudents" :items="stud_list" item-text="name" item-value="id"
                        label="Students" multiple chips outlined dense @change="showGenerateTable = false">

                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                                <span>{{ item.name }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text text-caption">
                                (+{{ selectedStudents.length - 1 }} others)
                            </span>
                        </template>

                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="selected_all_students" @change="toggle_student">
                                        <template #label>
                                            <span class="ml-8">Select All</span>
                                        </template>
                                    </v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>

                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" v-if="selectedStudents">
                    <v-select v-model="principal" :items="principal_list" item-text="name"
                        item-value="id" label="Principal" outlined dense />
                </v-col>
            </v-row>
            <v-row class="mt-2" justify="center">
                <v-radio-group v-model="mode" row>
                    <v-radio label="Fetch" value="FETCH"></v-radio>
                    <v-radio label="Generate" value="GENERATE"></v-radio>
                </v-radio-group>
            </v-row>
            <v-row justify="center" v-if="mode === 'FETCH'">
                <v-btn color="success" @click="fetchBulkLC">
                    Proceed
                </v-btn>
            </v-row>
            <div>
                <template v-if="mode === 'GENERATE'">
                    <v-row dense>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="last_date_of_school" label="Last Date of Leaving" outlined dense />
                        </v-col>

                        <v-col cols="12" sm="3">
                            <v-text-field v-model="gen_date" label="Generation Date" outlined dense />
                        </v-col>

                        <v-col cols="12" sm="3">
                            <v-text-field v-model="application_date" label="Date of Application" outlined dense />
                        </v-col>

                        <v-col cols="12" sm="3">
                            <v-text-field v-model="issue_date" label="Date of Issue" outlined dense />
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-checkbox v-model="mark_inactive" label="Mark students inactive after LC generation" />
                    </v-row>

                    <v-row justify="center" dense>
                        <v-btn color="success" class="mt-4" :disabled="selectedStudents.length === 0"
                            @click="getBulkLCData">
                            PROCEED
                        </v-btn>
                    </v-row>
                </template>
                <br>
            </div>
        </v-card>

        <div v-if="mode === 'GENERATE' && showGenerateTable">
            <v-data-table :headers="headers" :items="students" item-key="id" v-model="selectedRows"
                class="elevation-2 mt-4 mx-2 custom-table">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense color="white">
                        <v-toolbar-title class="font-weight-bold">
                            Student LC Details
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <span class="white--text text--darken-1">
                            Total: {{ students.length }}
                        </span>
                    </v-toolbar>
                </template>

                <template v-slot:item.progress="{ item }">
                    <v-select v-model="item.progress" :items="dvt_prog" item-text="value" item-value="value" dense
                        outlined hide-details class="table-select" />
                </template>

                <template v-slot:item.conduct="{ item }">
                    <v-select v-model="item.conduct" :items="dvt_conduct" item-text="value" item-value="value" dense
                        outlined hide-details class="table-select" />
                </template>

                <template v-slot:item.remark="{ item }">
                    <v-select v-model="item.remark" :items="dvt_remark" item-text="value" item-value="value" dense
                        outlined hide-details class="table-select" />
                </template>

                <template v-slot:item.reason="{ item }">
                    <v-select v-model="item.reason" :items="dvt_reason" item-text="value" item-value="value" dense
                        outlined hide-details class="table-select" />
                </template>
            </v-data-table>
            <v-row justify="center" dense>
                <v-btn color="success" class="mt-4" :disabled="selectedStudents.length === 0" @click="generateBulkLC">
                    Generate LC
                </v-btn>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            mark_inactive: false,
            overlay: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            registration_no: null,
            stud_list: [],
            dvt_prog: [],
            progress: null,
            dvt_conduct: [],
            conduct: null,
            dvt_reason: [],
            reason: null,
            dvt_remark: [],
            remark: null,
            last_date_of_school: "",
            gen_date: "",
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            date_of_application: new Date().toISOString().substr(0, 10),
            date_of_issue: "",
            application_date: "",
            issue_date: "",
            lc_data: null,
            current_ay: null,
            org_basic_data: null,
            org_id: null,
            section: '',
            ay: null,
            division: null,
            standard: null,
            standard_list_no_all: [],
            division_list: [],
            sections_list: [],
            ay_list: [],
            stud_list: [],
            headers: [
                { text: "PRN", value: "prn" },
                { text: "Student Name", value: "name" },
                { text: "Progress", value: "progress",width: '180px',class: 'fixed-col' },
                { text: "Conduct", value: "conduct",width: '180px',class: 'fixed-col' },
                { text: "Remark", value: "remark",width: '180px',class: 'fixed-col' },
                { text: "Reason", value: "reason" ,width: '180px',class: 'fixed-col'},
            ],
            mode: "GENERATE",
            students: [],
            selectedRows: [],
            selectedStudents: [],
            selected_all_students: false,
            showGenerateTable: false,
            principal_list:[],
            principal:null,
        };
    },
    watch: {
        mode(val) {
            if (val !== "GENERATE") {
                this.showGenerateTable = false
                this.students = []
            }
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            axios
                .post("AccountingAndFees/getReceipts")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                        this.sections_list = res.data.sections_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        clearSelected(){
            this.standard = null
            this.division = null
            this.principal = null
            this.division_list = []
            this.stud_list = []
            this.showGenerateTable = false;
            this.selectedStudents = [];
                axios
                    .post("Certificate/getPrincipalList")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.principal_list = res.data.principal_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
        },
        getStandardBySection() {
            this.standard = null
            this.division = null
            this.division_list = []
            this.stud_list = []
            this.showGenerateTable = false;
            this.selectedStudents = [];
            const data = {
                section: this.section,
            };
            axios
                .post("/AccountingAndFees/getStandardBySection", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard_list_no_all = res.data.standard_list_no_all;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => { });
        },
        getDivOffByStandard() {
            this.division = null
            this.stud_list = []
            this.showGenerateTable = false;
            this.selectedStudents = [];
            this.selected_all_students = false;
            const data = {
                section: this.section,
                ay: this.ay,
                standard: this.standard,
            };
            axios
                .post("/AccountingAndFees/getDivOffByStandard", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.division_list = res.data.division_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => { });
        },
        getStud() {
            this.showGenerateTable = false;
            this.selectedStudents = [];
            const payload = {
                ay_id: this.ay,
                div_off_id: this.division,
                status: "0",
            };

            axios
                .post("/sanjivaniExamination/getStudentByStdDiv", payload)
                .then((res) => {
                    this.stud_list = res.data.stud_list || [];
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Failed to fetch students");
                });
        },
        toggle_student() {
            this.$nextTick().then(() => {
                if (this.selected_all_students) {
                    this.selectedStudents = [];
                    for (var x in this.stud_list) {
                        this.selectedStudents.push(this.stud_list[x].id);
                    }
                } else {
                    this.selectedStudents = [];
                }
            });
        },
        prepareStudents(res) {

            const getDefault = (list) => {
                let def = list.find(x => x.isdefault)
                return def ? def.value : null
            }

            const progDefault = getDefault(this.dvt_prog)
            const conductDefault = getDefault(this.dvt_conduct)
            const remarkDefault = getDefault(this.dvt_remark)
            const reasonDefault = getDefault(this.dvt_reason)

            this.students = res.data.students.map(s => ({
                ...s,
                id: s.lid,
                progress: s.progress || progDefault,
                conduct: s.conduct || conductDefault,
                remark: s.remark || remarkDefault,
                reason: s.reason || reasonDefault
            }))
        },
        getBulkLCData() {
            const data = {
                lids: this.selectedStudents
            }

            this.overlay = true;

            axios.post("/certificate/getBulkLCData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {

                        this.dvt_prog = res.data.dvt_prog;
                        this.dvt_conduct = res.data.dvt_conduct;
                        this.dvt_reason = res.data.dvt_reason;
                        this.dvt_remark = res.data.dvt_remark;

                        this.prepareStudents(res);
                        this.showGenerateTable = true;

                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                })
                .catch(this.onerror)
                .finally(() => {
                    this.overlay = false;
                });
        },
        async generateBulkLC() {
            if (!this.selectedStudents.length) {
                this.showSnackbar("red", "Select students")
                return
            }

            this.overlay = true

            try {
                const payload = {
                    students: this.students,
                    last_date_of_school: this.last_date_of_school,
                    gen_date: this.gen_date,
                    date_of_application: this.application_date,
                    date_of_issue: this.issue_date,
                    mark_inactive: this.mark_inactive,
                    selected_ay: this.ay,
                    principal: this.principal
                }

                let res = await axios.post("/certificate/genBulkLC", payload)

                if (res.data.flag !== "YES") {
                    this.showSnackbar("red", res.data.snackbar)
                    return
                }

                localStorage.setItem("bulk_lc_html", res.data.bulk_html)

                window.open("/bulk-lc-print", "_blank")

            } catch (e) {
                console.error(e)
                this.onerror(e)
            } finally {
                this.overlay = false
            }
        },
        async fetchBulkLC() {
            if (!this.selectedStudents.length) {
                this.showSnackbar("red", "Please select students")
                return
            }

            this.overlay = true

            try {
                let res = await axios.post("/certificate/fetchBulkLC", {
                    lids: this.selectedStudents,
                    copy_name: "ORIGINAL",
                    selected_ay: this.ay,
                    principal: this.principal
                })

                if (res.data.flag !== "YES") {
                    this.showSnackbar("red", res.data.snackbar)
                    return
                }

                let finalHtml = ""

                res.data.html_list.forEach(html => {
                    finalHtml += html
                    finalHtml += '<div style="page-break-after: always;"></div>'
                })

                localStorage.setItem("bulk_lc_html", finalHtml)

                window.open("/bulk-lc-print", "_blank")

            } catch (e) {
                console.error(e)
                this.onerror(e)
            } finally {
                this.overlay = false
            }
        }
    },
    mounted() {
        localStorage.setItem("lc_data", null);
        localStorage.setItem("org_basic_data", null);
        localStorage.setItem("last_date_of_school", "");
        this.onload();
        this.clearSelected();
        this.last_date_of_school = this.formatDate(this.date);
        this.gen_date = this.formatDate(this.date2);
        this.application_date = this.formatDate(this.date_of_application);
        this.issue_date = this.formatDate(this.date_of_issue);
        this.org_id = localStorage.getItem("EPS-org-id")
    },
};
</script>
<style scoped>
.custom-table {
    border-radius: 10px;
    overflow: hidden;
}

.custom-table .v-data-table-header {
    background-color: #f5f5f5;
    font-weight: 600;
}

.custom-table td {
    padding: 8px !important;
}

.table-select .v-input__control {
    min-height: 32px !important;
}

.table-select .v-select__selections {
    font-size: 13px;
}
.custom-table >>> thead tr {
    background-color: #e1e3e5;
}

.custom-table >>> thead th {
    font-weight: 600;
    font-size: 13px;
}

.custom-table >>> th.fixed-col,
.custom-table >>> td.fixed-col {
    width: 220px !important;
    min-width: 220px !important;
    max-width: 220px !important;
}

.custom-table >>> td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>